
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Padding, Size } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Padding`}</h1>
<p>{`Low level component used to wrap other elements with padding.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Padding } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<div style={{ border: '1px solid red', display: 'inline-block' }}>
  <Padding>
    <div style={{ background: 'green', height: 100, width: 100 }} />
  </Padding>
</div>`} component={Padding} mdxType="Playground">
  <div style={{
        border: '1px solid red',
        display: 'inline-block'
      }}>
    <Padding mdxType="Padding">
      <div style={{
            background: 'green',
            height: 100,
            width: 100
          }} />
    </Padding>
  </div>
</Playground>
<p>{`You can also pass an object to specify the padding on each side. You can pass an object containing each side definition (`}<inlineCode parentName="p">{`left`}</inlineCode>{`, `}<inlineCode parentName="p">{`right`}</inlineCode>{`, `}<inlineCode parentName="p">{`top`}</inlineCode>{`, `}<inlineCode parentName="p">{`bottom`}</inlineCode>{`) or each direction (`}<inlineCode parentName="p">{`vertical`}</inlineCode>{`, `}<inlineCode parentName="p">{`horizontal`}</inlineCode>{`). Each key can contain a value of `}<inlineCode parentName="p">{`Size`}</inlineCode>{`.`}</p>
<p>{`As you can see, the paddings are not combined and each element keeps its padding as expected.`}</p>
<Playground __position={1} __code={`<>
  <Padding
    size={{
      top: Size.LARGE,
      bottom: Size.EXTRA_SMALL,
      left: Size.DEFAULT,
    }}
    style={{ border: '1px solid red' }}>
    <div style={{ background: 'green', height: 100, width: 100 }} />
  </Padding>
  <Padding
    size={{
      top: Size.LARGE,
      bottom: Size.EXTRA_SMALL,
      left: Size.MASSIVE,
    }}
    style={{ border: '1px solid red' }}>
    <div style={{ background: 'green', height: 100, width: 100 }} />
  </Padding>
  <Padding
    size={{
      vertical: Size.SMALL,
      left: Size.LARGE,
    }}
    style={{ border: '1px solid red' }}>
    <div style={{ background: 'green', height: 100, width: 100 }} />
  </Padding>
</>`} mdxType="Playground">
  <>
    <Padding size={{
          top: Size.LARGE,
          bottom: Size.EXTRA_SMALL,
          left: Size.DEFAULT
        }} style={{
          border: '1px solid red'
        }} mdxType="Padding">
      <div style={{
            background: 'green',
            height: 100,
            width: 100
          }} />
    </Padding>
    <Padding size={{
          top: Size.LARGE,
          bottom: Size.EXTRA_SMALL,
          left: Size.MASSIVE
        }} style={{
          border: '1px solid red'
        }} mdxType="Padding">
      <div style={{
            background: 'green',
            height: 100,
            width: 100
          }} />
    </Padding>
    <Padding size={{
          vertical: Size.SMALL,
          left: Size.LARGE
        }} style={{
          border: '1px solid red'
        }} mdxType="Padding">
      <div style={{
            background: 'green',
            height: 100,
            width: 100
          }} />
    </Padding>
  </>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;